import React from "react";
import {
  Dialog,
  DialogContent,
  Button,
  DialogTitle,
  Avatar,
  CircularProgress,
} from "@mui/material";
import Decrypt from "../utils/Decrypt";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FormatTimestamp from "../../helperFunctions/FormatDateTimestamp";
import GlobalButton from "../utils/GlobalButton";
const DeletedUsersRestore = ({
  list = [],
  type,
  openModal,
  getAllList,

  getAllDeletedUsers,
  loading,
  setIsTrashModalOpen,
  setTrashLoading,
}) => {
  const serverURL = process.env.REACT_APP_URL;

  const getTitle = () => {
    switch (type) {
      case "IP":
        return "Installation Partner";
      case "VENDOR":
        return "Vendor";
      case "CAMPAIGN":
        return "Campaign";
      case "CONTRACTOR":
        return "Contractor";
      default:
        return "Items";
    }
  };
  const onClose = () => {
    setIsTrashModalOpen(false);
  };

  const handleRestore = async (item) => {
    try {
      let response;
      setTrashLoading(true);

      if (type === "IP") {
        const response = await axios.patch(
          `${serverURL}/installationPartner/edit/${item._id}`,
          { isDeleted: false },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (response.data.success) {
          getAllList();
          await getAllDeletedUsers();
        }
      } else if (type === "VENDOR") {
        response = await axios.put(
          `${serverURL}/api/vendors/${item._id}`,
          { isDeleted: false },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response.data.success) {
          getAllList();
          await getAllDeletedUsers();
        }
      } else if (type === "CAMPAIGN") {
        response = await axios.put(
          `${serverURL}/campaign/editCampaign/${item._id}`,
          {
            isDeleted: false,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response.data.success) {
          getAllList();
          await getAllDeletedUsers();
        }
      } else if (type === "CLIENT") {
        response = await axios.put(
          `${serverURL}/organization/update/${item._id}`,
          {
            isDeleted: false,
            restoreDeleted: true,
            gstin: item.gstin,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response.data.success) {
          getAllList();

          await getAllDeletedUsers();
        }
      } else if (type === "CONTRACTOR") {
        response = await axios.put(
          `${serverURL}/installationPartnerSupervisor/edit/${item._id}`,
          {
            isDeleted: false,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response.data.success) {
          getAllList();

          await getAllDeletedUsers();
        }
      } else if (type === "ENQUIRY") {
        response = await axios.put(
          `${serverURL}/requestForProposal/editRfp/${item._id}`,
          {
            isDeleted: false,
            emailAddress: item?.campaignOwnerId.emailAddress,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response.data.success) {
          getAllList();

          await getAllDeletedUsers();
        }
      } else if (type === "USERS") {
        response = await axios.put(
          `${serverURL}/users/${item._id}`,
          {
            isDeleted: false,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response.data.success) {
          getAllList();

          await getAllDeletedUsers();
        }
      }
    } catch (error) {
      console.error("Restore failed:", error);
    } finally {
      setTrashLoading(false);
    }
  };

  return (
    <Dialog
      open={openModal}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      {" "}
      <div className="flex justify-between items-center">
        <DialogTitle>
          <h1 className="bold"> Deleted {getTitle()} List </h1>
          <p className="semi-bold">Total: {list.length}</p>{" "}
        </DialogTitle>

        {/* ❌ Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "gray",
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent>
        {loading ? (
          <>
            <div className="flex justify-center items-center gap-4 h-[400px] overflow-y-auto pr-2">
              {" "}
              <CircularProgress />
            </div>
          </>
        ) : list.length === 0 ? (
          <div className="text-center text-gray-500 flex justify-center items-center gap-4 h-[400px] overflow-y-auto pr-2">
            No deleted items found
          </div>
        ) : (
          <div className="flex flex-col gap-4 h-[400px] overflow-y-auto pr-2">
            {list.map((item, index) => (
              <div
                key={item?._id || index}
                className="flex items-center justify-between border rounded-xl p-3 shadow-sm"
              >
                {/* 🔹 LEFT SIDE (Avatar + Info) */}
                <div className="flex items-center gap-3">
                  <Avatar
                    src={
                      item.profilePhoto ||
                      item.ProfilePhoto ||
                      item.brandLogo ||
                      item.profilePic
                    }
                    alt={item.name}
                    sx={{ width: 60, height: 60 }}
                  />

                  <div className="flex flex-col">
                    {item?.vendorBusinessName && (
                      <span className="font-semibold text-sm">
                        {item?.vendorBusinessName}
                      </span>
                    )}

                    {item?.name && (
                      <span className="font-semibold text-sm">
                        {item?.name ||
                          item?.campaignTitle ||
                          (item?.ownerName && `${Decrypt(item?.ownerName)} `) ||
                          "No Name"}
                      </span>
                    )}
                    {item?.rfpSerialNumber && (
                      <span className="font-semibold text-sm">
                        {item?.rfpSerialNumber}
                      </span>
                    )}
                    {item?.campaignName && (
                      <span className="font-semibold text-sm">
                        {item?.campaignName}
                      </span>
                    )}
                    {item?.campaignTitle && (
                      <span className="font-semibold text-sm">
                        {item?.campaignTitle}
                      </span>
                    )}

                    {item?.phoneNumber && (
                      <span className="text-xs text-gray-500">
                        📞{" "}
                        {item?.phoneNumber.length > 15
                          ? Decrypt(item?.phoneNumber)
                          : item?.phoneNumber}
                      </span>
                    )}

                    {item?.ownerPrimaryContactNo && (
                      <span className="text-xs text-gray-500">
                        📞 {Decrypt(item?.ownerPrimaryContactNo)}
                      </span>
                    )}

                    {/* ✅ NEW FIELD */}
                    {item?.updatedAt && (
                      <span className="text-xs text-gray-500">
                        🗑️ Deleted On:{" "}
                        {
                          <FormatTimestamp
                            timestamp={item.updatedAt}
                            time={true}
                          />
                        }
                      </span>
                    )}
                  </div>
                </div>

                {/* 🔹 RIGHT SIDE (Restore Button) */}
                <div className="width-32px">
                  <GlobalButton
                    variant="primary"
                    size="small"
                    color="primary"
                    onClick={() => handleRestore(item)}
                  >
                    {`Restore`}
                  </GlobalButton>
                </div>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DeletedUsersRestore;
